import { extractLoyaltyId, extractLoyaltyProgram } from '@/src/core/utils/loyaltyUtils'
import { ResultType, TerminalApiResponse } from '@adyen/api-library/lib/src/typings/terminal/models'

export type PaymentStatusType = 'idle' | 'loading' | 'success' | 'error'

function PaymentStatus({
	status,
	terminalResponse,
	error,
	onDismiss,
	customerName,
}: {
	status: PaymentStatusType
	terminalResponse?: TerminalApiResponse
	error?: string
	onDismiss: () => void
	customerName: string
}) {
	if (status === 'idle' || !terminalResponse) return

	const result = terminalResponse.SaleToPOIResponse?.PaymentResponse?.Response?.Result
	const hasLoyaltyId = extractLoyaltyId(extractLoyaltyProgram(terminalResponse))

	return (
		<div className="mb-8 rounded-lg border border-white/10 bg-white/5 p-4">
			{error ? (
				<div className="flex items-center justify-between">
					<div>
						<h2 className="text-lg font-medium text-red-400">Sale Failed</h2>
						<p className="mt-1 text-sm text-white/70">{error}</p>
					</div>
					<button
						type="button"
						onClick={onDismiss}
						className="rounded-md bg-white/10 px-4 py-2 text-sm transition-colors hover:bg-white/20"
					>
						Dismiss
					</button>
				</div>
			) : result === ResultType.Success ? (
				<div className="flex items-center justify-between">
					<div>
						<h2 className="text-lg font-medium text-[#66d697]">Sale Complete</h2>
						<p className="mt-1 text-sm text-white/70">Transaction completed.</p>
						{customerName ? (
							<p className="mt-2 text-sm text-[#66d697]">Welcome back, {customerName}!</p>
						) : hasLoyaltyId ? (
							<p className="mt-2 text-sm text-[#66d697]">Welcome back!</p>
						) : undefined}
					</div>
					<button
						type="button"
						onClick={onDismiss}
						className="rounded-md bg-white/10 px-4 py-2 text-sm transition-colors hover:bg-white/20"
					>
						Dismiss
					</button>
				</div>
			) : (
				<div className="flex items-center justify-between">
					<div>
						<h2 className="text-lg font-medium text-red-400">Sale Failed</h2>
						<p className="mt-1 text-sm text-white/70">Try again.</p>
					</div>
					<button
						type="button"
						onClick={onDismiss}
						className="rounded-md bg-white/10 px-4 py-2 text-sm transition-colors hover:bg-white/20"
					>
						Dismiss
					</button>
				</div>
			)}
		</div>
	)
}

export default PaymentStatus
